import React from "react";
import { Layout, AddressLAGToken } from "../components";

const AddressLAGPage = () => {
  return (
    <>
      <Layout>
        <AddressLAGToken />
      </Layout>
    </>
  );
};

export default AddressLAGPage;
